import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { hideSideBar, openSideBar } from '../../store/sidebarSlice';
import { isOvum, isStageOrDevEnv } from '../../utils/utils';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const errorState = location.state as { error?: string; componentStack?: string };

  useEffect(() => {
    dispatch(hideSideBar());
    return () => {
      dispatch(openSideBar());
    };
  }, [dispatch]);
  
  const handleRedirect = () => {
    if(isOvum()) {
      if(isStageOrDevEnv()) {
        window.location.href = 'https://app.gohighlevel.com/v2/preview/sN6Gdb06Y0pRmUAxLhwA';
      } else {
        window.location.href = 'https://ovumhealth.com';
      }
    } else {
      navigate('/');
    }
  };

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center p-8 bg-white rounded-lg shadow-xl max-w-lg">
        <h1 className="text-4xl font-bold text-red-600 mb-4">Oops! Something went wrong</h1>
        <p className="mt-4 text-lg text-gray-700 mb-6">
          {errorState?.error || 'We encountered an unexpected error. Please try again later.'}
        </p>
        
        <div className="flex justify-center gap-4">
          <button
            onClick={handleRetry}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
          >
            Retry
          </button>
          <button
            onClick={handleRedirect}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Go to Home
          </button>
        </div>

        {/* @ts-ignore */}
        {errorState?.componentStack && process.env.NODE_ENV === 'development' && (
          <div className="mt-8 text-left">
            <p className="text-sm text-gray-500 font-mono whitespace-pre-wrap">
              {errorState?.componentStack}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorPage; 